export default {
  title: 'Components/DDA Split Button/DDA Split Button',
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component: `
To use the \`<dda-split-button>\` component, pass the following props:

\`\`\`html
<dda-split-button
    button_color="default-primary"
    start_icon="sentiment_satisfied"
    button_text: "Button"
    end_icon="arrow_forward"
    custom_class=""
    component_mode=""
    text_button_id="button"
    aria_label="button"
    text_button_name="button"
    value="my-value"
    >
</dda-split-button>
\`\`\`

To listen for click events:

\`\`\`javascript
document.querySelector('dda-split-button').addEventListener('buttonClick', (e) => {
  const { event, id, value, name } = e.detail;
  console.log('Button clicked:', { id, value, name });
});
\`\`\`
        `,
      },
    },
  },
  argTypes: {
    button_color: {
      control: { type: 'select' },
      options: [
        'default-primary','default-secondary','default-tertiary','default-link',
        'error-primary','error-secondary','error-tertiary','error-link',
        'onsurface-primary','onsurface-secondary','onsurface-tertiary','onsurface-link',
        'secondary','success','warning','surface','surface-variant','disabled',
      ],
    },
    text_button_type: { control: 'select', options: ['button', 'submit', 'reset'] },
    size: { control: 'select', options: ['sm', 'md', 'lg', 'xl'] },
    button_shape: { control: 'select', options: ['default', 'circle'] },
    toggle_button_shape: { control: 'select', options: ['default', 'circle'] },
    gap: { control: 'select', options: [1, 2] },
    button_text: { control: 'text' },
    custom_class: { control: 'text' },
    component_mode: {
      control: { type: 'select' },
      options: ['dark-mode', 'light-mode'],
      description: 'Mode of the button component',
    },
    text_button_id: { control: 'text', description: 'ID of the button' },
    aria_label: { control: 'text', description: 'Aria label for the button' },
    text_button_name: { control: 'text', description: 'Name of the button' },
    value: { control: 'text', description: 'Value of the button' },
    disabled: { control: 'boolean', description: 'Disable the button' },
  },
};



const Template = (args) => {
  const attributes = Object.entries(args)
    .filter(([key, value]) => value !== undefined && key !== 'text')
    .map(([key, value]) => {
      if (key === 'onClick') {
        return `onclick="${value}"`; // inject raw JS string
      }
      return `${key}="${value}"`;
    })
    .join(' ');

  // Manually add the onclick attribute with a placeholder JS snippet or text
  const onclickAttr = 'onclick="console.log(\'native click\')"';

  // Create the button element HTML string including onclick
  const buttonHtml = `<dda-split-button ${attributes} ${onclickAttr}></dda-split-button>`;
  
  // Add event listener after the element is created (unchanged)
  setTimeout(() => {
    const button = document.querySelector(`dda-split-button[button_id="${args.text_button_id}"]`);
    if (button) {
      button.removeEventListener('buttonClick', handleButtonClick);
      button.addEventListener('buttonClick', handleButtonClick);
    }
  }, 0);

  return buttonHtml;
};

const handleButtonClick = (e) => {
  const { event, id, value, name } = e.detail;
  console.log('Button clicked:', { id, value, name });
  console.log('Mouse event:', event);

  if (id === 'error-button') {
    alert('Hello! I am an alert box!!');
  } else if (id === 'console-button') {
    console.log('Button clicked via custom event');
  }
};

export const DefaultPrimary = Template.bind({});
DefaultPrimary.args = {
  text_button_type: "button",
  button_color: 'default-primary',
  start_icon: 'sentiment_satisfied',
  button_text: 'Button',
  text_button_id: 'default-primary-btn',
  aria_label: 'default primary button',
  text_button_name: 'defaultPrimaryButton',
  value: 'default-primary-value',
  button_shape: 'default',
  size: 'md',
  gap: 1,
  disabled: false,
  custom_class: '',
  component_mode: '',
  onclick: "console.log('native click')"
};

export const ErrorPrimary = Template.bind({});
ErrorPrimary.args = {
  ...DefaultPrimary.args,
  button_color: 'error-primary',
  start_icon: 'sentiment_satisfied',
  button_text: 'Button',
  text_button_id: 'default-primary-btn',
  aria_label: 'default primary button',
  text_button_name: 'defaultPrimaryButton',
  value: 'default-primary-value',
  button_shape: 'default',
  size: 'md',
  gap: '1',
  disabled: false,
  custom_class: '',
  component_mode: '',
  onclick: "console.log('native click')"
};

export const SurfacePrimary = Template.bind({});
SurfacePrimary.args = {
  ...DefaultPrimary.args,
  button_color: 'onsurface-primary',
  start_icon: 'sentiment_satisfied',
  button_text: 'Button',
  text_button_id: 'default-primary-btn',
  aria_label: 'default primary button',
  text_button_name: 'defaultPrimaryButton',
  value: 'default-primary-value',
  button_shape: 'default',
  size: 'md',
  gap: '1',
  disabled: false,
  custom_class: '',
  component_mode: '',
  onclick: "console.log('native click')"
};

export const Disabled = Template.bind({});
Disabled.args = {
  ...DefaultPrimary.args,
  button_color: 'disabled',
  text_button_id: 'disabled-button',
  disabled: true,
  custom_class: '',
  component_mode: '',
  onclick: "console.log('native click')"
};

export const IconButton = Template.bind({});
IconButton.args = {
  text_button_type: "button",
  button_color: 'default-primary',
  start_icon: 'sentiment_satisfied',
  text_button_id: 'icon-button',
  aria_label: 'icon button',
  text_button_name: 'iconButton',
  value: 'icon-value',
  toggle_button_shape: "default",
  size: 'md',
  disabled: false,
  custom_class: '',
  component_mode: '',
  onclick: "console.log('native click')"
};

export const IconButtonDisabled = Template.bind({});
IconButtonDisabled.args = {
  ...IconButton.args,
  button_color: 'disabled',
  text_button_id: 'icon-button-disabled',
  disabled: true,
  custom_class: '',
  component_mode: '',
  onclick: "console.log('native click')"
};
